import { CheckCircle2, Globe2, ListChecks } from "lucide-react";
import { Container } from "@/components/ui/container";
import { SectionHeading } from "@/components/ui/section-heading";
import { Badge } from "@/components/ui/badge";
import { websiteConsentPoints } from "@/lib/content";

export function WebsitePrivacyConsent() {
  return (
    <section aria-labelledby="website-consent-heading" className="bg-secondary/30 py-16 sm:py-24">
      <Container className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
        <div>
          <SectionHeading
            align="left"
            titleId="website-consent-heading"
            eyebrow="Website Privacy & Consent"
            title="Connect website consent to the rest of your privacy work."
            description="The launch product is designed to treat website consent as an operational privacy module — not just a banner pasted onto a site."
            className="max-w-xl"
          />
          <div className="mt-6 flex flex-wrap gap-2">
            <Badge variant="brand">Launch capability</Badge>
            <Badge variant="outline">Automated scanner: later phase</Badge>
          </div>
        </div>

        <div className="min-w-0 rounded-2xl border border-border bg-card p-6 shadow-card sm:p-8">
          <div className="grid gap-5 sm:grid-cols-2">
            <div className="rounded-xl bg-accent p-5 text-accent-foreground">
              <Globe2 className="h-6 w-6" aria-hidden="true" />
              <p className="mt-4 text-sm font-semibold">example.com</p>
              <p className="mt-1 text-xs leading-relaxed">
                Example configuration: Philippines DPA + GDPR / EU modules active.
              </p>
            </div>
            <div className="rounded-xl border border-border p-5">
              <ListChecks className="h-6 w-6 text-primary" aria-hidden="true" />
              <p className="mt-4 text-sm font-semibold text-foreground">Consent categories</p>
              <p className="mt-1 text-xs leading-relaxed text-muted-foreground">
                Necessary · Preferences · Analytics · Marketing
              </p>
            </div>
          </div>

          <ul className="mt-6 space-y-3">
            {websiteConsentPoints.map((point) => (
              <li key={point} className="flex gap-3 text-sm leading-relaxed text-muted-foreground">
                <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-success" aria-hidden="true" />
                <span>{point}</span>
              </li>
            ))}
          </ul>

          <p className="mt-6 rounded-lg bg-secondary/50 px-4 py-3 text-xs leading-relaxed text-muted-foreground">
            System-generated consent events use separate operational quotas and retention rules. They do not consume the normal five-record Free allowance or customer attachment-storage quota.
          </p>
        </div>
      </Container>
    </section>
  );
}
